import Heading from '../Heading';
import P from '../P';

const IpTrademarks = () => (
  <>
    <Heading tx="ip_trademarks_heading" />
    <P tx="ip_trademarks_content" />
  </>
);

export default IpTrademarks;
